import { _ } from "../../../../core/polyglot/polyglot.js";
import {
	cancelLinkRenderer,
	footerButtonsRenderer,
} from "../../../../core/widgets/dialogs/footers/footers.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import ItemPicker from "../../../../core/widgets/ItemPicker/ItemPicker.js";
import popoverWidget from "../../../../core/widgets/popoverWidget/popoverWidget.js";
import regionWidget from "../../../../core/widgets/regionWidget.js";

/**
 * Render a "Attach report" button which displays a popover letting
   the user select a report from a list.
 */
export default class ReportAttachmentButtonWidget extends Widget {
	constructor({ reports, onReportSelection }) {
		super(...arguments);

		this._reportItems = this._makeItemsFromReports(reports);
		this._onReportSelection = onReportSelection;
		this._popover = this._makePopover();
	}

	renderContentOn(html) {
		const button = html.button(
			{
				class: "btn btn-primary btn-inline-block",
				"data-test": "attach-report",
			},
			_("Attach reports"),
		);

		this._popover.setTriggerItem(button);
	}

	_popoverFooterRenderer({ itemPicker }) {
		return (html) =>
			html.div(
				html.div({ class: "popover-divider" }),
				footerButtonsRenderer({
					mainButtons: [
						cancelLinkRenderer({
							hide: () => this._popover.hide(),
						}),
						html.button(
							{
								class: "btn btn-primary",
								disabled: !itemPicker.getValue(),
								"data-test": "apply",
								click: () => {
									this._popover.hide();

									this._onReportSelection(
										itemPicker.getValue(),
									);
								},
							},
							_("Attach"),
						),
					],
				}),
			);
	}

	_makePopover() {
		const itemPicker = new ItemPicker({
			items: this._reportItems,
			itemRenderer: (item) => item.title,
			standalone: true,
		});

		const footerRegion = regionWidget({
			content: (html) => {
				html.render(this._popoverFooterRenderer({ itemPicker }));
			},
		});

		itemPicker.selectionChanged.register(() => footerRegion.update());

		return popoverWidget({
			header: _("Attach a custom report"),
			content: itemPicker,
			footer: footerRegion,
		});
	}

	_makeItemsFromReports(reports) {
		return reports.map((report) => ({
			title: report.getTitle(),
			value: report,
			match: (searchString) => report.match(searchString),
		}));
	}
}
